import { render, staticRenderFns } from "./ArtistTours copy 3.vue?vue&type=template&id=63da9c47&"
import script from "./ArtistTours copy 3.vue?vue&type=script&lang=js&"
export * from "./ArtistTours copy 3.vue?vue&type=script&lang=js&"
import style0 from "./ArtistTours copy 3.vue?vue&type=style&index=0&id=63da9c47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports